// extracted by mini-css-extract-plugin
module.exports = {"reward":"Reward_reward__2aopr","awardTable":"Reward_awardTable__1CBBf"};